module.exports = __webpack_public_path__ + "static/media/point_icon_01.f6951451.svg";